import React from "react";
import { Text, Tooltip } from "@chakra-ui/react";
import { getFormattedNumValue } from "../../../../../../utils";

const CustomStackedBar = ({ barItemData }) => {
  const { x, y, width, height, data } = barItemData;
  const detailedData = data.data.detailedData;
  const selectedYearData = detailedData[data.id];

  const heightValue = data.value;
  const heightScalePercentage = heightValue !== 0 ? height / heightValue : 0;
  const scopeOneHeightInPX = Math.floor(selectedYearData.scopeOneTotalCo2Emissions * heightScalePercentage);
  const scopeTwoHeightInPX = Math.floor(selectedYearData.scopeTwoTotalCo2Emissions * heightScalePercentage);

  const scopeOneHeightYCoordinate = y + height - scopeOneHeightInPX;
  const scopeTwoHeightYCoordinate = y + height - scopeTwoHeightInPX;

  const scopeOneValue = detailedData?.[barItemData.data.id]?.scopeOneTotalCo2Emissions ?? null;
  const scopeTwoValue = detailedData?.[barItemData.data.id]?.scopeTwoTotalCo2Emissions ?? null;

  return (
    <g>
      {
        (scopeOneValue && scopeOneValue > 0 && scopeOneHeightInPX === 0) ||
        (scopeTwoValue && scopeTwoValue > 0 && scopeTwoHeightInPX === 0) ?
          <Tooltip
            fontSize={"sm"}
            fontWeight="normal"
            rounded={"md"}
            padding={"15px 10px"}
            bg="white"
            color="black"
            placement="auto"
            label={
              <>
                {scopeOneValue && scopeOneValue > 0 && scopeOneHeightInPX === 0 ?
                  <Text fontSize="sm">
                    {data.id}, Scope 1
                    - {data.data.dimensionItem}: <b>{getFormattedNumValue(detailedData[barItemData.data.id].scopeOneTotalCo2Emissions)}</b> tCO<sub>2e</sub>
                  </Text> : null
                }
                {scopeTwoValue && scopeTwoValue > 0 && scopeTwoHeightInPX === 0 ?
                  <Text fontSize="sm">
                    {data.id}, Scope 2
                    - {data.data.dimensionItem}: <b>{getFormattedNumValue(detailedData[barItemData.data.id].scopeTwoTotalCo2Emissions)}</b> tCO<sub>2e</sub>
                  </Text> : null
                }
              </>
            }
          >
            <circle
              cx={x + width / 2}
              cy={scopeOneHeightYCoordinate - scopeTwoHeightInPX - 3}
              r="3"
              fill={"hsl(183,11%,67%)"}
            />
          </Tooltip> : null
      }
      <Tooltip
        fontSize={"sm"}
        fontWeight="normal"
        rounded={"md"}
        padding={"15px 10px"}
        bg="white"
        color="black"
        placement="auto"
        label={
          <Text fontSize="sm">
            {data.id}, Scope 1
            - {data.data.dimensionItem}: <b>{getFormattedNumValue(detailedData[barItemData.data.id].scopeOneTotalCo2Emissions)}</b> tCO<sub>2e</sub>
          </Text>
        }
      >
        <rect
          fill={"hsla(50,100%,50%,0.49)"}
          height={scopeOneHeightInPX}
          width={width}
          x={x}
          y={scopeOneHeightYCoordinate - scopeTwoHeightInPX}
        />
      </Tooltip>
      <Tooltip
        fontSize={"sm"}
        fontWeight="normal"
        rounded={"md"}
        padding={"15px 10px"}
        bg="white"
        color="black"
        placement="auto"
        label={
          <Text fontSize="sm">
            {data.id}, Scope 2
            - {data.data.dimensionItem}: <b>{getFormattedNumValue(detailedData[barItemData.data.id].scopeTwoTotalCo2Emissions)}</b> tCO<sub>2e</sub>
          </Text>
        }
      >
        <rect
          fill={"hsla(0,100%,50%,0.62)"}
          height={scopeTwoHeightInPX}
          width={width}
          x={x}
          y={scopeTwoHeightYCoordinate}
        />
      </Tooltip>
    </g>
  );
};

export default CustomStackedBar;